import { useToastContext } from '@/contexts/toastContext';
import useApiSubmit from '@/hooks/useApiSubmit';
import candidatesServices, {
  CandidateResponse,
  PartialCandidateToSubmit,
} from '@/services/candidates';
import { PersonType } from '@/types/api';
import PersonalInfoPageContent, {
  Props as ComponentProps,
} from './PersonalInfoPageContent.component';

type Props = Pick<ComponentProps, 'person'> & {
  onUpdateUser?: () => void;
  toastSuccessText?: string;
  isMyPersonalInfo?: boolean;
};

const PersonalInfoPageContentContainer = ({
  onUpdateUser,
  toastSuccessText,
  isMyPersonalInfo,
  ...componentProps
}: Props): JSX.Element => {
  const toast = useToastContext();

  const updateCandidateMutation = useApiSubmit<CandidateResponse, PartialCandidateToSubmit>(
    candidatesServices.updateCandidateIndividuallyById
  );

  const updateMyPersonalInfo = useApiSubmit<CandidateResponse, PartialCandidateToSubmit>(
    candidatesServices.updateCandidatePersonalInfo
  );

  const updateCandidateQuery = isMyPersonalInfo ? updateMyPersonalInfo : updateCandidateMutation;

  const handleSubmit = async (data: Omit<Partial<PersonType>, 'id'>): Promise<void> => {
    try {
      toast.setMessage('Saving information...');
      toast.setSeverity('info');
      toast.showToast();

      await updateCandidateQuery.mutateAsync({
        candidate: {
          ...data,
          id: componentProps.person?.id,
        },
      });

      toast.setMessage(toastSuccessText || 'The personal information has been updated.');
      toast.setSeverity('success');
      toast.showToast();
      // refreshUser?.();
      onUpdateUser?.();
    } catch {
      toast.setMessage('There was an error saving the data.');
      toast.setSeverity('error');
      toast.showToast();
    }
  };

  return (
    <PersonalInfoPageContent
      onSubmit={handleSubmit}
      isMyPersonalInfo={isMyPersonalInfo}
      {...componentProps}
    />
  );
};

export default PersonalInfoPageContentContainer;
